export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ04.24162678.mp3";